<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner">
    <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
        <h1 class="display-5 font-weight-bold mx-auto">{{'Livres blancs' | translate}}</h1>
    </div>
</div>
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title">{{'Téléchargez notre dernier livre blanc !' | translate}}</span>
    </div>
</div>
<div class="block-featured-event py-5">
    <div class="container px-5">
        <div class="block px-4 py-5">
            <div class="container">
                <div class="row">

                    <div class="col-12 col-md-7">
                        <b class="event-title">{{featuredWhitePaper[0].title}}</b>
                        <span class="date my-3">{{featuredWhitePaper[0].createdDate}}</span>
                        <p class="description">{{'Le challenge du groupe Suez ? Atteindre l’objectif zéro accident grave et mortel d’ici 2030. Pour ce faire, Suez a fait appel à Immersive Factory qui a développé des modules de formation visant à renforcer la culture santé & sécurité dans les Business Units du groupe.' | translate}}<br>{{'Après une période de «test & learn» et quelques autres initiatives locales, Suez a décidé de déployer les solutions d’Immersive Factory à l’international. Implémentant, de ce fait, la Réalité Virtuelle (VR) dans les programmes de formations de presque tous les pays. Outre la valeur ajoutée et la facilité de déploiement des solutions d’Immersive Factory, les retours terrain ont surtout été très positifs.' | translate}}<br>{{'Découvrez, au travers de ce livre blanc, comment Immersive Factory a collaboré avec Suez pour renforcer sa culture santé & sécurité : l’histoire du groupe, le challenge visé, la solution apportée, les indicateurs de succès, etc ..' | translate}}</p>
                    </div>

                    <div class="col-12 col-md-5 mt-3 mt-md-0">
                        <picture>
                            <source srcset="assets/{{'Livre_Blanc_Suez_FR' | translate}}.webp" type="image/webp">
                            <source srcset="assets/{{'Livre_Blanc_Suez_FR' | translate}}.jpg" type="image/jpg">
                            <img src="assets/{{'Livre_Blanc_Suez_FR' | translate}}.jpg" class="block-rounded mb-2" alt="Cover of the white paper" title="white paper" loading="lazy">
                        </picture>
                        <div class="text-cente btn-white-paper">
                            <a type="button" class="btn btn-sign-up rounded-pill my-4 cursor-pointer" (click)="clickOnDownload(featuredWhitePaper[0])"><i class="fas fa-download pr-2"></i>{{'Télécharger' | translate}}</a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title">{{'Découvrez tous nos livres blancs' | translate}}</span>
    </div>
</div>


<div class="container mt-5" id="news">
    <!-- <ul class="filtres d-flex flex-wrap justify-content-center mb-3">
        <li (click)="selectTag(null)" class="rounded" [ngClass]="{'active': !activeTag}">{{'Tout' | translate}}</li>
        <li *ngFor="let tag of tags" class="rounded" (click)="selectTag(tag['id'])" [ngClass]="{'active': activeTag == tag.id}">{{tag.title}}</li>
    </ul> -->
    <div class="categories autres mb-5 pb-3">
        <div class="d-flex flex-column flex-md-row flex-wrap">


            <div class="col-md-6 col-lg-4 mb-4" *ngFor="let actu of listWhitePapers">
                <div class="post rounded border" *ngIf="listWhitePapers">

                    <div class="imagewhite mb-3">
                      <picture>
                          <source srcset="{{actu.img}}.webp" type="image/webp">
                          <source srcset="{{actu.img}}.jpg" type="image/jpg">
                          <img src="{{actu.img}}.jpg" class="imgHeader" alt="cover of the white paper called {{actu.title}}" title="{{actu.title}}" loading="lazy">
                      </picture>
                    </div>

                    <div class="informations mb-3 px-3">
                        <span class="white-paper-date">{{actu.createdDate}}</span>
                        <!-- <div class="tag rounded px-2">{{actu.tag['title']}}</div> -->
                    </div>
                    <div class="actu-body px-3">
                        <span class="white-paper-title mb-3">{{actu.title}}</span>
                        <p class="white-paper-description">{{actu.shortDesc}}</p>
                        <span (click)="clickOnDownload(actu)" class="viewmore mb-3 cursor-pointer">{{'Télécharger' | translate}}</span>
                    </div>
                </div>


            </div>
        </div>
        <nav class="text-center" *ngIf="listWhitePapers.length<nbPosts && tagLimit==false">
            <button class="btn btn-action" (click)="showMoreActu()">{{'Afficher plus' | translate}}</button>
        </nav>
    </div>
</div>

<div class="modal fade" tabindex="-1" role="dialog" id="contact-modal" data-backdrop="false" aria-labelledby="contactModalLabel" aria-hidden="true" (click)="hideModalContact()">
    <div class="modal-dialog modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="contactModalLabel">{{'Laissez-nous vos coordonnées' | translate}}</h5>
                <button type="button" class="close" (click)="hideModalContact()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body p-3">
                <div class="mb-2">
                    <input type="text" class="form form-control" onclick="$(event.target).removeClass('is-invalid')" placeholder="{{'Nom' | translate}}" [ngClass]="{'is-invalid':problem.name}" [(ngModel)]="name"/>
                </div>
                <div class="mb-2">
                    <input class="form-control" [ngClass]="{'is-invalid':problem.company}" name="company" placeholder="{{'Entreprise' | translate}}" type="text" [(ngModel)]="company">
                </div>
                <div class="my-2">
                    <input type="email" class=" form-control" onclick="$(event.target).removeClass('is-invalid')" placeholder="{{'Email' | translate}}" [ngClass]="{'is-invalid':problem.mail}" [(ngModel)]="mail"/>
                </div>
                <div class="my-2">
                    <app-intl-tel-input [(ngModel)]="tel" [ngClass]="{'is-invalid':problem.tel}" onclick="$(event.target).removeClass('is-invalid')"></app-intl-tel-input>
                </div>
                <div class="my-2">
                    <select class="custom-select" [(ngModel)]="country">
                        <option [value]="null" disabled>{{'Pays' | translate}}</option>
                        <option [value]="c['code']" *ngFor="let c of allCountries">{{c['name']}}</option>
                    </select>
                </div>
                <div class="my-2">
                    <select class="custom-select" [(ngModel)]="interest" value="whitepaper">
                        <option value="event" disabled>{{'L’évènement ou la conférence' | translate}}</option>
                        <option value="whitepaper">{{'Le dernier livre blanc' | translate}}</option>
                        <option value="testimony" disabled>{{'Les témoignages clients' | translate}}</option>
                        <option value="partner" disabled>{{'Un partenariat revendeur' | translate}}</option>
                        <option value="demo" disabled>{{'Une démo/ un appel avec un commercial' | translate}}</option>
                        <option value="newsletter" disabled>{{'La newsletter' | translate}}</option>
                    </select>
                </div>
                <div class="my-2">
                    <textarea placeholder="{{'Message' | translate}}" size=20 class="  form-control" onclick="$(event.target).removeClass('is-invalid')" [ngClass]="{'is-invalid':problem.message}" [(ngModel)]="message"></textarea>
                </div>
                <div class="mt-2">
                    <re-captcha #captcha *ngIf="captchaDisplay" siteKey="6LcPqFUUAAAAAG84T0vZSmcSa_0dQKMjhVQBrWDs"></re-captcha>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-action cursor-pointer" id="validButton" [ngClass]="{'disabled' : sendDisabled}" (click)="sendForm()" [disabled]="sendDisabled"> {{'Envoyer' | translate}}</button>
            </div>
        </div>
    </div>
</div>

<!-- Don't touch this, it's for Google Ads metrics -->
<app-iframe-gratitude *ngIf="showGratitude" iframeurl="/gratitude/contact.html" (iframeLoaded)="iframeLoaded()"></app-iframe-gratitude>
